import { isUnauthenticatedError } from 'lib/helpers/isUnauthenticatedError/isUnauthenticatedError'
import { isExpectedNotFound } from '../isExpectedNotFound/isExpectedNotFound'

/**
 * True for the error classes `ContentErrorBoundary` handles gracefully and deliberately
 * does not report — an expected not-found, or a 401 whose `/login` redirect the global
 * Apollo error link already owns.
 *
 * Shared with the RUM `beforeSend` filter, which drops React's `console.error` re-log of
 * the same throw. Both sides reading one predicate is what stops them from drifting: a
 * class silenced in the boundary but not in RUM is still reported, just from the other path.
 */
export const isSilencedByBoundary = (error: unknown): boolean =>
  isExpectedNotFound(error) || isUnauthenticatedError(error)
